import { Button, ButtonGroup } from '@mui/material';
import React from 'react';

type CoordinateInputMode = 'decimal' | 'dms';

type CoordinateInputModeButtonGroupProps = {
    ariaLabel: string
    mode: CoordinateInputMode
    onChangeMode: (mode: CoordinateInputMode) => void
}

export const CoordinateInputModeButtonGroup: React.FC<CoordinateInputModeButtonGroupProps> = (props) => {
    return (
        <ButtonGroup size="small" variant="outlined" aria-label={props.ariaLabel}>
            <Button
                variant={props.mode === 'dms' ? 'contained' : 'outlined'}
                disableElevation
                sx={{ boxShadow: 'none', '&:hover': { boxShadow: 'none' } }}
                onClick={() => props.onChangeMode('dms')}
            >
                60進法
            </Button>
            <Button
                variant={props.mode === 'decimal' ? 'contained' : 'outlined'}
                disableElevation
                sx={{ boxShadow: 'none', '&:hover': { boxShadow: 'none' } }}
                onClick={() => props.onChangeMode('decimal')}
            >
                10進法
            </Button>
        </ButtonGroup>
    );
};
